import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * Üst/alt widget barı — clock, date.
 * Clock setInterval 1s ile reactive update.
 * NOT: Hava durumu artık BAŞLIKTA (fp-header, Open-Meteo ile GERÇEK). Buradaki eski
 * sahte (sabit 21°C) hava kaldırıldı; 'weather' seçilse de gösterilmez.
 */
@customElement('fp-widget-bar')
export class FpWidgetBar extends LitElement {
    @property({ type: Array }) widgets: string[] = [];

    @state() private now: Date = new Date();
    private timer?: number;

    createRenderRoot(): HTMLElement {
        return this;
    }

    connectedCallback(): void {
        super.connectedCallback();
        // Dakika hassasiyeti (HH:MM) — saniye gereksiz (L4). 15sn yenileme yeterli.
        this.timer = window.setInterval(() => {
            this.now = new Date();
        }, 15_000);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        if (this.timer !== undefined) {
            clearInterval(this.timer);
            this.timer = undefined;
        }
    }

    render() {
        return html`
            <div class="flex gap-4 items-center justify-end px-4 py-2"
                 style="background: var(--fp-surface, var(--fp-color-surface)); color: var(--fp-color-fg);">
                ${this.widgets.includes('clock') ? html`
                    <span class="font-mono text-xl tabular-nums"
                          style="font-family: var(--fp-font-numeric);">
                        ${this.now.toLocaleTimeString('tr-TR', { timeZone: 'Europe/Istanbul', hour: '2-digit', minute: '2-digit' })}
                    </span>` : ''}
                ${this.widgets.includes('date') ? html`
                    <span class="text-sm" style="color: var(--fp-color-fg-muted);">
                        ${this.now.toLocaleDateString('tr-TR', { timeZone: 'Europe/Istanbul', weekday: 'long', day: 'numeric', month: 'long' })}
                    </span>` : ''}
            </div>
        `;
    }
}
